import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { CurrentUser } from '../services/currentUser.service';
import { UserAccount } from '../services/userAccount.service';
import { AppConfigService } from '../services/app-config.service';
import { Location } from '@angular/common';
import { RouterExtService } from 'app/services/routerExt.service';
import { catchError } from 'rxjs/operators';
import { ProfileService } from 'app/+profile/profile.service';
import { CountriesService } from 'app/services/countries.service';

@Injectable()
export class AccountService {
  private baseUrl = environment.API;
  public isModalShown = false;
  public modalType = 'login';
  projectId;
  invitationToken;
  isDone: boolean;
  private modalCallback: () => void = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toasterService: ToasterService,
    private currentUser: CurrentUser,
    private userAccount: UserAccount,
    private appConfigService: AppConfigService,
    private _ngZone: NgZone,
    private profileService: ProfileService,
    private countriesService: CountriesService,
  ) {}

  public login(user, redirectUrl?) {
    const url = `${this.baseUrl}/token/`;
    return this.authorize(user, url, false, redirectUrl, false);
  }

  public signUp(user) {
    const url = `${this.baseUrl}/users/register/`;
    return this.authorize(user, url, false, undefined, true);
  }

  public signInWithFacebook(accessToken, redirectUrl, isSignUp) {
    const url = `${this.baseUrl}/token/provider/facebook/`;
    return this.authorize({access_token: accessToken}, url, true, redirectUrl, isSignUp);
  }

  public signInWithGoogle(accessToken, redirectUrl, isSignUp) {
    const url = `${this.baseUrl}/token/provider/google-oauth2/`;
    return this.authorize({access_token: accessToken}, url, false, redirectUrl, isSignUp);
  }

  public signUpWithApple(data, redirectUrl, isSignUp) {
    const url = `${this.baseUrl}/token/provider/apple-id/`;
    return this.authorize(data, url, false, redirectUrl, isSignUp);
  }


  public reset(user) {
    const url = `${this.baseUrl}/users/account/password/reset/`;
    return this.http.post(url, user).pipe(catchError(err => {
      return throwError(err);
    }));
  }

  public changePassword(password) {
    const url = `${this.baseUrl}/users/account/password/reset/confirm/`;
    const params = {
      password: password,
      ...this.activatedRoute.snapshot.queryParams,
    };
    return this.http.post(url, params, { responseType: 'text' });
  }

  public confirmPasswordReset(payload) {
    const url = `${this.baseUrl}/users/account/password/reset/confirm/`;
    return this.http.post(url, payload, { responseType: 'text' });
  }

  public activate() {
    const url = `${this.baseUrl}/users/account/activate/`;
    const params = this.activatedRoute.snapshot.queryParams;
    return this.http.post(url, params, { responseType: 'text' });
  }

  public closeModal() {
    this.isModalShown = false;
    this.modalType = 'login';
    this.modalCallback = null;
  }

  public openModal(callback) {
    this.isModalShown = true;
    this.modalCallback = callback;
  }

  navigate(isFbAuth, redirectUrl?) {
    if (this.router.url.includes('/contribute') || redirectUrl) {
      const urlArray = redirectUrl.split('?token=');
      const path = urlArray[0];
      const token = urlArray[1];

      this.router.navigate([path],
      {queryParams: {token: token, done: this.isDone }});
    } else {
      if (isFbAuth) {
        this._ngZone.run(() => {
          this.router.navigate(['/stories']);
        });
      } else {
        this.router.navigate(['/stories']);
      }
    }

  }

  private authorize(user, url, isFbAuth = false, redirectUrl?, isSignUp?) {
    return Observable.create(observer => {
      this.http.post(url, user).subscribe(
        data => {
          if (isSignUp) {
            user.country_code = this.appConfigService.config.geo_info['country_code'];
            if (!this.countriesService.get(user.country_code)) {
              user.country_code = 'US';
            }
            this.profileService.save(user).subscribe();
          }
          this.currentUser.set({
            username: user.username, refresh_token: data['refresh_token'] ? data['refresh_token'] : '',
            access_token: data['access_token'] ? data['access_token']  : '', method: isFbAuth ? 'facebook' : 'email' });
          this.userAccount.get();
          this.appConfigService.load();
          if (this.isModalShown) {
            this.modalCallback();
            this.closeModal();
          } else {
            if (redirectUrl) {
              window.location.href = this.currentUser.authenticateUrl(redirectUrl);
            } else {
              this.navigate(isFbAuth, redirectUrl);
            }
          }
          observer.next(data);
          observer.complete();
        },
        data => {
          const error = data.error;
          if (error.detail) {
            this.toasterService.pop('error', undefined, error.detail);
          }
          observer.error(data);
          observer.complete();
        }
      );
    });
  }
}
